import blogPoster1 from 'url:../assets/images/blog-poster-1.webp';
import blogPoster2 from 'url:../assets/images/blog-poster-2.webp';
import blogPoster3 from 'url:../assets/images/blog-poster-3.webp';

export interface BlogPost {
  id: number;
  image: string;
  title: string;
  description: string;
  onPress?: () => void;
}

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 0,
    image: blogPoster1,
    title: 'How AI is changing personal training forever',
    description:
      'Discover how AI-powered motion tracking and real-time feedback are transforming workouts — making personal training accessible to everyone, anywhere.',
  },
  {
    id: 1,
    image: blogPoster2,
    title: 'Why motivation isn’t enough',
    description:
      'Learn why willpower fades and how smart workout guidance keeps you on track, even when motivation dips.',
  },
  {
    id: 2,
    image: blogPoster3,
    title: 'How to prepare for your miniPT workout',
    description:
      'Learn the simple steps to get ready for your session — from setting up your space to warming up, so every workout is effective and safe.',
  },
];
